// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectProduct_custom-select__wVokG","header-select":"SelectProduct_header-select__WM8-e"};